import { Autocomplete, Box, Button, MenuItem, Select, TextField, InputAdornment, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as api from '../services/api'
import Loader from '../../components/Loader'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import dayjs from 'dayjs'
import { useLocation } from 'react-router-dom';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import ModalCalendar from '../../components/modal/ModalCalendar'
import moment from 'moment/moment'

function EditUser() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [gender, setGender] = useState([])
    const [titlename, setTitlename] = useState([])
    const [department, setDepartment] = useState([])
    const [usertype, setUsertype] = useState([])

    const [profilePic, setProfilePic] = useState();
    const [openCalendar, setOpenCalendar] = useState(false)
    const [disabledDay, setDisabledDay] = useState([])

    const location = useLocation();
    const { cardId } = location.state || {};

    const [data, setData] = useState({
        uid: "",
        user_type: "", //ประเภทผู้ใช้งาน
        card_id: "", //เลขบัตรประชาชน
        gender: "", //เพศ
        titlename: "", //ยศ
        firstname: "", //ชื่อ
        lastname: "", //นามสกุล
        email: "",
        phone: "", //หมายเลขโทรศัพท์
        department_name: "", //สังกัด
        department_code: "",
        image_url: "",
        birthday: dayjs(new Date())
    });

    const [isValidpid, setIsValidpid] = useState(false);
    const [isValidphone, setIsValidphone] = useState(false);

    const fetchUserData = async (page, search) => {
        setLoading(true);
        const res = await api.findUser(page, search);
        setLoading(false);
        if (res) {
            if (res['data']['code'] === 200) {
                const detail = res['data']['data'][0];
                setData({ ...detail, birthday: dayjs(detail['dob']) });
                setProfilePic(detail['image_url'])
                // setTotalPage(res['data']['pagging']['totalPage'])
            } else {
                //alert(res['data']['message']);
                navigate('/manageUsers')
            }
        } else {
            alert("ไม่ตอบสนอง");
        }
    };

    useEffect(() => {
        findGender()
        findTitleName()
        findUserGroup()
        findDepartment()
        fetchUserData(1, cardId)
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const clickUpdate = () => {
        let inform = {
            // image_url: file,
            uid: data['uid'],
            user_type: data['user_type'],
            card_id: data['card_id'],
            gender: data['gender'],
            titlename: data['titlename'],
            firstname: data['firstname'],
            lastname: data['lastname'],
            email: data['email'],
            phone: data['phone'],
            department_code: data['department_code'],
            dob: formatDate(data['birthday'])
        }
        update(inform)
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    const findGender = async () => {
        setLoading(true)
        let res = await api.gender()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                setGender(res['data']['data'])
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const findTitleName = async () => {
        setLoading(true)
        let res = await api.titleName()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                let option = []
                for (let i = 0; i < res['data']['data'].length; i++) {
                    if (res['data']['data'][i]) {
                        option.push({
                            key: res['data']['data'][i]['value'],
                            label: res['data']['data'][i]['name']
                        })
                    }
                    const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
                    // console.log(unique)
                    setTitlename(unique)
                }
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const findUserGroup = async () => {
        setLoading(true)
        let res = await api.findUserGroup()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                // console.log(res['data']['data'])
                setUsertype(res['data']['data'])
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const findDepartment = async () => {
            setLoading(true)
            let res = await api.findDepartmentFixToken()
            setLoading(false)
            if (res) {
                if (res['data']['code'] == 200) {
                    let option = []
                    for (let i = 0; i < res['data']['data'].length; i++) {
                        if (res['data']['data'][i]) {
                            option.push({
                                key: res['data']['data'][i]['department_code'],
                                label: res['data']['data'][i]['department_name']
                            })
                        }
                        const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
                        // console.log(unique)
                        setDepartment(unique)
                    }
                } else {
                    //alert(res['data']['message'])
                }
            } else {
                alert('ไม่ตอบสนอง')
            }
        }

    const formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    const update = async (inform) => {
        setLoading(true)
        let res = await api.updateUser(inform, data['uid'])
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                alert('บันทึกสำเร็จ');
                navigate('/manageUsers')
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            {openCalendar &&
                <ModalCalendar
                    onClose={() => { setOpenCalendar(false) }}
                    onSubmit={() => { setOpenCalendar(false) }}
                    value={
                        data['birthday'] ? dayjs(moment(data['birthday']['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))
                    }
                    setValue={(e) => {
                        setData({ ...data, birthday: e });
                    }}
                    disableDay={disabledDay}
                />
            }
            <Loader loading={loading} />

            <Box sx={design.container}>
                <Box sx={design.mainSection}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gridGap: '10px',
                    }}>
                        <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                        <Box sx={{
                            cursor: 'pointer'
                        }}
                            onClick={() => { navigate('/manageUsers') }}
                        >กลับไป จัดการผู้ใช้งาน</Box>
                    </Box>
                    <Box sx={{ mt: 2, color: '#478F96', fontWeight: 600 }}>แก้ไขข้อมูลผู้ใช้งาน</Box>


                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        fontSize: '20px',
                        "@media (max-width: 1100px)": {
                            fontSize: '16px',
                        },
                        "@media (max-width: 800px)": {
                            fontSize: '14px',
                        },
                    }}>
                        <Box sx={{
                            display: 'grid',
                            gridGap: '20px',
                            width: '700px',
                            "@media (max-width: 1100px)": {
                                width: '500px'
                            },
                            "@media (max-width: 800px)": {
                                width: '100%'
                            },
                        }}>
                            <Box sx={{ textAlign: 'center', mt: 3 }}>
                                <Box
                                    component="label"
                                    sx={{
                                        display: 'inline-flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: 100,
                                        height: 100,
                                        borderRadius: '50%',
                                        backgroundColor: '#ccc',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {profilePic ? (
                                        <img src={profilePic} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    ) : (
                                        <Box sx={{ color: '#fff', fontSize: '1.5em' }}></Box>
                                    )}
                                </Box>


                            </Box>

                            <Box>
                                <Box>ประเภทผู้ใช้งาน</Box>
                                <Select
                                    size="small"
                                    fullWidth
                                    value={data['user_type'] || "null"}
                                    name={"user_type"}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="null" disabled>
                                        เลือกประเภทผู้ใช้งาน
                                    </MenuItem>
                                    {usertype.map((i, idx) => (
                                        <MenuItem key={idx} value={i['group_code']}>{i['group_name']}</MenuItem>
                                    ))}
                                </Select>
                            </Box>

                            <Box>
                                <Box>เลขบัตรประจำตัวประชาชน</Box>
                                <TextField
                                    placeholder='กรอกเลขบัตรประจำตัวประชาชน'
                                    size="small"
                                    fullWidth
                                    value={data["card_id"]}
                                    name={"card_id"}
                                    onChange={handleChange}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                borderColor: isValidpid ? 'red' : '',
                                            }
                                        },
                                    }}
                                />
                            </Box>

                            <Box>
                                <Box>เพศ</Box>
                                <Select
                                    size="small"
                                    fullWidth
                                    value={data["gender"] || "null"}
                                    name={"gender"}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="null" disabled>
                                        เลือกเพศ
                                    </MenuItem>
                                    {gender.map((i, idx) => (
                                        <MenuItem key={idx} value={i['value']}>{i['name']}</MenuItem>
                                    ))}
                                </Select>
                            </Box>

                            <Box>
                                <Box>สังกัด</Box>
                                <Autocomplete
                                    fullWidth
                                    size='small'
                                    options={department}
                                    value={data['department_name']}
                                    name='department_name'
                                    onChange={(e, value) => {
                                        setData({ ...data, 'department_name': value?.['label'], 'department_code': value?.['key'] });
                                    }}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                            placeholder="เลือกสังกัด"
                                        />
                                    }
                                />
                            </Box>

                            <Box>
                                <Box>ยศ</Box>
                                <Autocomplete
                                    fullWidth
                                    size='small'
                                    options={titlename}
                                    value={data["titlename"]}
                                    name='titlename'
                                    onChange={(e, value) => {
                                        setData({ ...data, 'titlename': value?.['label'] });
                                    }}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                            placeholder="เลือกยศ"
                                        />
                                    }
                                />
                            </Box>

                            <Box>
                                <Box sx={{ display: 'flex', gridGap: '10px' }}>
                                    <Box>ชื่อและนามสกุลที่แสดงในระบบ</Box>
                                    <Box sx={{ color: '#687982' }}>กรุณาใช้ชื่อและนามสกุลจริง</Box>
                                </Box>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gridGap: '20px',
                                    "@media (max-width: 800px)": {
                                        gridTemplateColumns: '1fr',
                                    },
                                }}>
                                    <TextField
                                        placeholder="ชื่อ"
                                        size="small"
                                        fullWidth
                                        value={data["firstname"]}
                                        name={"firstname"}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        placeholder="นามสกุล"
                                        size="small"
                                        fullWidth
                                        value={data["lastname"]}
                                        name={"lastname"}
                                        onChange={handleChange}
                                    />
                                </Box>
                            </Box>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridGap: '20px',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr',
                                },
                            }}>
                                <Box>
                                    <Box>อีเมล</Box>
                                    <TextField
                                        placeholder="กรอกอีเมล"
                                        size="small"
                                        fullWidth
                                        value={data["email"]}
                                        name={"email"}
                                        onChange={handleChange}
                                    />
                                </Box>
                                <Box>
                                    <Box>เบอร์โทร</Box>
                                    <TextField
                                        placeholder="กรอกเบอร์โทร"
                                        size="small"
                                        fullWidth
                                        value={data["phone"]}
                                        name={"phone"}
                                        onChange={handleChange}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: isValidphone ? 'red' : '',
                                                }
                                            },
                                        }}
                                    />
                                </Box>
                            </Box>

                            <Box>
                                <Box>วันเกิด</Box>
                                <TextField
                                    fullWidth
                                    size='small'
                                    value={data['birthday'] === '' ? 'เลือกวันเกิด' : convertDate(data['birthday'])}
                                    InputProps={{
                                        inputProps: {
                                            readOnly: true,
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => { setOpenCalendar(true) }}
                                                >
                                                    <CalendarTodayIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>
                            <Box sx={{ textAlign: 'center' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: "150px",
                                        "@media (max-width: 800px)": {
                                            width: "100px",
                                        },
                                    }}
                                    onClick={() => {
                                        if (!data['user_type']) {
                                            return alert('กรุณาเลือกประเภทผู้ใช้งาน')
                                        }
                                        if (!data['card_id']) {
                                            return alert('กรุณากรอกเลขบัตรประจำตัวประชาชน')
                                        }
                                        if (data['card_id']) {
                                            const regex = /^\d{13}$/;
                                            if (!regex.test(data['card_id'])) {
                                                setIsValidpid(true);
                                                return alert('กรุณาตรวจสอบเลขบัตรประจำตัวประชาชน')
                                            } else {
                                                setIsValidpid(false)
                                            }
                                        }
                                        if (!data['gender']) {
                                            return alert('กรุณาเลือกเพศ')
                                        }
                                        if (!data['titlename']) {
                                            return alert('กรุณาเลือกยศ')
                                        }
                                        if (!data['firstname']) {
                                            return alert('กรุณากรอกชื่อ')
                                        }
                                        if (!data['lastname']) {
                                            return alert('กรุณากรอกนามสกุล')
                                        }
                                        if (!data['email']) {
                                            return alert('กรุณากรอกอีเมล')
                                        }
                                        if (!data['phone']) {
                                            return alert('กรุณากรอกเบอร์โทรศัพท์')
                                        }
                                        if (data['phone']) {
                                            const regex = /^\d{10}$/;
                                            if (!regex.test(data['phone'])) {
                                                setIsValidphone(true)
                                                return alert('กรุณาตรวจสอบเบอร์โทรศัพท์')
                                            } else {
                                                setIsValidphone(false)
                                            }
                                        }
                                        if (!data['department_code']) {
                                            return alert('กรุณาเลือกสังกัด')
                                        }
                                        if (!data['birthday']) {
                                            return alert('กรุณาเลือกวันเกิด')
                                        }
                                        clickUpdate()
                                    }}
                                >บันทึก</Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

const design = {
    container: {
        display: "flex",
        bgcolor: "neutral.light",
    },
    mainSection: {
        px: { xl: 4, lg: 4, md: 4, sm: 2, xs: 2 },
        py: { xl: 4, lg: 4, md: 4, sm: 2, xs: 2 },
        width: "100%",
        height: "100%",
        overflow: "auto",
    },
};

export default EditUser